import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { EsriJSON, KML, GeoJSON, GPX, TopoJSON } from 'ol/format';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { transform } from 'ol/proj';
import { saveAs } from 'file-saver';

export const addVectorService = (form, map, format, crs) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsText(form.target.files[0]);
    fileReader.onload = (e) => {
      let vektorData = e.target.result;
      let sourceFormat;
      let currentProj = map.getView().getProjection();
      const source = new VectorSource();

      switch (format) {
        case 'esrijson':
          sourceFormat = new EsriJSON();
          break;
        case 'geojson':
          sourceFormat = new GeoJSON();
          break;
        case 'gpx':
          sourceFormat = new GPX();
          break;
        case 'kml':
          sourceFormat = new KML();
          break;
        case 'shapefile':
          //sourceFormat = new GeoJSON();
          break;
        case 'topojson':
          sourceFormat = new TopoJSON();
          break;
        default:
          return false;
      }

      const options = {
        dataProjection: crs,
        featureProjection: currentProj,
      };

      const features = sourceFormat.readFeatures(vektorData, options);
      features.forEach((feature) => {
        feature.getGeometry().transform(crs, currentProj);
      });
      source.addFeatures(features);

      let vectorUpload = new VectorLayer({
        source: source,
        title: 'Yüklenen Veri Katmanı',
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2,
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33',
            }),
          }),
        }),
      });

      const layerExtent = source.getExtent();
      vectorUpload.setExtent(layerExtent);

      resolve(vectorUpload);
      map.addLayer(vectorUpload);
      setTimeout(function () {
        map.getLayers().forEach(function (e) {
          if (e.get('title') === 'Yüklenen Veri Katmanı') {
            e.state_.extent = e.renderer_.renderedExtent_;
            map.getView().fit(layerExtent);
          }
        });
      }, 500);
    };
  });
};

export const downloadVektorService = (format, layer, crs) => {
  let downloader = (data, ext) => {
    let file = new Blob([data], {
      type: 'text/plain;charset=utf-8',
    });
    saveAs(file, 'veri.' + ext);
  };

  let features = layer.getSource().getFeatures();
  let featureProjection = layer.getSource().getProjection();

  if (crs && typeof crs === 'string' && crs.trim() !== '') {
    let crsCode = crs.trim();
    if (crsCode.startsWith('EPSG:')) {
      featureProjection = crsCode;
    } else {
      featureProjection = `EPSG:${crsCode}`;
    }
  }

  if (format === 'EsriJSON') {
    let format = new EsriJSON();
    let type = format.writeFeatures(features, {
      featureProjection: featureProjection,
    });
    return downloader(type, 'json');
  } else if (format === 'GeoJSON') {
    let format = new GeoJSON();
    let type = format.writeFeatures(features, {
      featureProjection: featureProjection,
    });
    return downloader(type, 'geojson');
  } else if (format === 'GPX') {
    let format = new GPX();
    let type = format.writeFeatures(features, {
      featureProjection: featureProjection,
    });
    return downloader(type, 'gpx');
  } else if (format === 'KML') {
    let format = new KML();
    let type = format.writeFeatures(features, {
      featureProjection: featureProjection,
    });
    return downloader(type, 'kml');
  } else if (format === 'TopoJSON') {
    let format = new TopoJSON();
    let type = format.writeFeatures(features, {
      featureProjection: featureProjection,
    });
    return downloader(type, 'topojson');
  } else {
    alert('Format kullanılamaz...');
  }
};
